// router/index.js 或 router.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from './views/Home'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/User',
    name: 'User',
    component: () => import('./views/User.vue'),
    meta: {
      title: '用户中心'
    }
  },
  {
    path: '/UserInfoPop',
    name: 'UserInfoPop',
    component: () => import('./views/UserInfoPop.vue'),
    meta: {
      title: '弹窗更新'
    }
  },
  {
    path: '/SaveUserInfo',
    name: 'SaveUserInfo',
    component: () => import('./views/SaveUserInfo.vue'),
    meta: {
      title: '用户信息更新'
    }
  },
  {
    path: '/JfExchange',
    name: 'JfExchange',
    component: () => import('./views/JFExchange.vue'),
    meta: {
      title: '积分兑换'
    }
  },
  {
    path: '/jkjt',
    name: 'jkjt',
    component: () => import('./views/jkjt.vue'),
    meta: {
      title: '健康讲堂'
    }
  },
  {
    path: '/jkjtLogin',
    name: 'jkjtLogin',
    component: () => import('./views/jkjtLogin.vue'),
    meta: {
      title: '健康讲堂登录'
    }
  }
  // 添加更多路由规则...
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
